export function memberInitials(name: string): string {
  const tokens = name.split(/\s+/).filter((token) => token.length > 0);

  if (tokens.length === 0) return '?';

  if (tokens.length === 1) return tokens[0]!.charAt(0).toUpperCase();

  return (tokens[0]!.charAt(0) + tokens[tokens.length - 1]!.charAt(0)).toUpperCase();
}
